export const flightOptionType = {
  baggage: "預け入れ手荷物",
  itinerary0Baggage: "預け入れ手荷物 (往路)",
  itinerary1Baggage: "預け入れ手荷物 (復路)",
  baggageWithText: "預け入れ手荷物の追加",
  seatSelectionWithText: "座席指定",
  mealWithText: "食事リクエスト",
  upgradeWithText: "アップグレード",
};
